import { Administracion } from '../../models/Administracion';

import { CACHE_ADMIN_MUTATION_AGREGAR_ADMIN, CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN, CACHE_ADMIN_MUTATION_OBTENER_UNA_ADMIN, CACHE_ADMIN_MUTATION_OBTENER_TODAS_ADMIN, CACHE_ADMIN_MUTATION_MODIFICAR_CONSORCIOS_ADMIN, CAAdministracionesCacheState } from './administraciones.types';


const state: CAAdministracionesCacheState = {
  cache_administraciones: [],
};

const LIMITE_CACHE = 10; // Limite de administraciones cacheadas

const getters = {

  /**
   * Metodo para recuperar todas las administraciones cacheadas
   * 
   * @param state 
   * @returns Lista de administraciones cacheadas
   */
  [CACHE_ADMIN_MUTATION_OBTENER_TODAS_ADMIN](state: CAAdministracionesCacheState){
    return state.cache_administraciones;
  },


  /**
  *  Metodo para buscar una administración en concreto (por ID) en las admin cacheadas
  * 
  * @param state 
  * @returns Retorna la administración si la encontro, caso contrario undefined
  */
  [CACHE_ADMIN_MUTATION_OBTENER_UNA_ADMIN]: (state: CAAdministracionesCacheState) => (admin_buscada: Administracion) => {
    let admin = state.cache_administraciones.find(administracion_cacheada => administracion_cacheada.id === admin_buscada.id);
    return admin;
  },

};

const mutations = {

  /**
   * Mutation para agregar una administracion a la cache, siempre y cuando esta no supere el limite definido
   * 
   * @param state 
   * @param admin Administracion
   */
  [CACHE_ADMIN_MUTATION_AGREGAR_ADMIN](state: CAAdministracionesCacheState, admin: Administracion){
    state.cache_administraciones.unshift(admin); // agrego al principio
    state.cache_administraciones.length > LIMITE_CACHE ? state.cache_administraciones.pop() : null; // si llego al limite, saco la ultima
  },

  /**
   * Mutation para eliminar una administracion a la cache
   * 
   * @param state 
   * @param admin_eliminada Administracion
   */
  [CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN](state: CAAdministracionesCacheState, admin_eliminada: Administracion){
    let index = state.cache_administraciones.findIndex((admin) => admin.id === admin_eliminada.id);
    index !== -1 ? state.cache_administraciones.splice(index, 1) : null;
  },

  /**
   * Setea los consorcios a la administración cacheada
   * 
   * @param state 
   * @param admin_modificada Administracion
   * @param consorcios_modificados Array de Consorcios
   */
  [CACHE_ADMIN_MUTATION_MODIFICAR_CONSORCIOS_ADMIN](state: CAAdministracionesCacheState, payload){
    let index = state.cache_administraciones.findIndex((admin) => admin.id === payload.admin_modificada.id);
    index !== -1 ? state.cache_administraciones[index].consorcios = payload.consorcios_modificados : null;
  }

};

export default {
  state,
  getters,
  mutations
};